/** `FinancialYearController`'s HTTP surface — thin GET-only wrapper, same pattern as `license.service.ts`. */
import { httpClient, unwrap, API_ENDPOINTS } from '@core/api';
import type { ApiSuccessResponse } from '@app-types/api.types';
import type { FinancialYearDto } from '@nexao/contracts';

export async function getCurrentFinancialYear(): Promise<FinancialYearDto | null> {
  try {
    return await unwrap(httpClient.get<ApiSuccessResponse<FinancialYearDto>>(`${API_ENDPOINTS.platform.financialYears}/current`));
  } catch (error) {
    // No current financial year configured yet — a real, expected state, not an error to surface (mirrors license.service.ts's own getCurrentLicense()).
    const status = (error as { statusCode?: number }).statusCode;
    if (status === 404) {
      return null;
    }
    throw error;
  }
}
